import { render, staticRenderFns } from "./InvoiceCustomerForm.vue?vue&type=template&id=24c71fda"
import script from "./InvoiceCustomerForm.vue?vue&type=script&lang=js"
export * from "./InvoiceCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./InvoiceCustomerForm.vue?vue&type=style&index=0&id=24c71fda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports